import {ActiveRecord} from '../ActiveRecord';
import config from 'config';
import {LiveImageDTO, LiveImage} from "../image";
// import isUndefined = require("lodash/isUndefined");
// import {CountryDTO} from "../country";

export class StreamImageDTO extends LiveImageDTO {
  small: string;
  small_url?: string;
  thumbnail_url?: string;
  url?: string;
  thumbnail: string;
}

export class StreamImage extends LiveImage {
  protected _small: string;
  protected _thumbnail: string;

  get small(): string {
    return this.isSaved ? this._small : this.url;
  }

  get thumbnail(): string {
    return this.isSaved ? this._thumbnail : this.url;
  }

  constructor(data: StreamImageDTO) {
    super({ ...data, original: data.original || data.url});
    this._small = data.small || data.small_url;
    this._thumbnail = data.thumbnail || data.thumbnail_url;
  }
}

export const STREAM_EVENT_STATUS_ACTIVE = 'active';
export const STREAM_EVENT_STATUS_PENDING = 'pending';
export const STREAM_EVENT_STATUS_FINISHED = 'finished';

export const STREAM_EVENT_UPCOMING = 'upcoming';
export const STREAM_EVENT_DRAFT = 'draft';
export const STREAM_EVENT_PAST = 'past';
export const STREAM_EVENT_LIVE = 'live';
export const VIDEO_ON_DEMAND = 'vod';

export enum StreamEventStatusType { OFF, CREATING, CREATE_FAILED, IDLE, STARTING, RUNNING, RECOVERING, STOPPING, DELETING, DELETED, UPDATING, UPDATE_FAILED }


export interface LiveStreamEventDTO {
  id?: string;
  logo?: StreamImageDTO;
  full_name: string;
  description: string;
  start_time: number;
  end_time?: number;
  vip_only?: boolean;
  m3u8?: string;
  rtmp_url?: string;
  channel_state?: StreamEventStatusType
  // countries?: CountryDTO[];
  // country_codes?: Array<string>;
}

export class LiveStadiumStreamEvent extends ActiveRecord {
  title: string;
  startDate: Date;
  endDate: Date;
  logo: LiveImage;
  m3u8: string;
  rtmp_url: string;
  channel_state: StreamEventStatusType
  
  static path = `${config.backOfficeBasePath}/streams/live`;

  static mapRecords(data) {
    return data.map((item) => this.parseData(item));
  }

  static parseData(data: LiveStreamEventDTO): LiveStadiumStreamEvent {
    let res = new LiveStadiumStreamEvent(data);
    return Object.assign(res, res._parseData(data));
  }

  prepareForSave(data): LiveStreamEventDTO {
    return {
      full_name: data.title,
      vip_only: data.vip_only,
      start_time: data.startDate.getTime(),
      end_time: data.endDate.getTime(),
      description: data.description,
      logo: data.logo && !data.logo.isSaved ? data.logo.file : undefined,
      // country_codes: data.countries
    };
  }

  _parseData(data: any) {
    let res: any = {
      id: data.id,
      // hack for api
      title: data.full_name,
      vip_only: data.vip_only,
      description: data.description,
      startDate: new Date(data.start_time),
      endDate: data.end_time ? new Date(data.end_time) : undefined,
      channel_state: data.channel_state,
      m3u8: data.m3u8,
      rtmp_url: data.rtmp_url,
      logo: data.logo? new StreamImage(Object.assign(new StreamImageDTO(), data.logo)) : undefined,
    };
    return res;
  }
  get hasVideo(): boolean {
    return this.m3u8 !== undefined;
  }
  async toggleMediaServer(start: boolean): Promise<LiveStadiumStreamEvent> {
    try { 
      let res = await this._networkLayer.postJson(this._prepareUrl(this.id) + '/media_server', {
        action: start ? 'start' : 'stop',
        type: 'rtmp_push'
      })
      return this
    } catch (e) { 
      throw e;
    }
  }
  async save(data: any): Promise<LiveStadiumStreamEvent> {
    await super.save(data);
    // if (data.logo && data.logo instanceof LiveImage && !data.logo.isSaved) {
    //   let responseUpdateLogo = await this._networkLayer.putFormData(this._prepareUrl(this.id) + '/logo', {
    //     logo: data.logo.file
    //   });
    //   let dataResponse = await responseUpdateLogo.json();
    //   this._afterSave(dataResponse);
    // }

    return this;
  }

  protected async _createRecord(dataForSave) {
    let res = await this._networkLayer.postFormData(this._prepareUrl(), dataForSave);
    return await res.json();
  }
  
  async publish(data): Promise<LiveStadiumStreamEvent> {
    return await this.save(Object.assign(data, {draft: false}));
  }

  protected async _updateRecord(dataForSave) {
    return await this._networkLayer.putFormData(this._prepareUrl(this.id), dataForSave);
  }
}



// WEBPACK FOOTER //
// ./src/api/stream/LiveStadiumStreamEvent.ts